<div class="modal-header">
    <h4 class="modal-title">Standort {{ title }}</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="newForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <label class="control-label" for="inputStrasse">Straße<span class="text-danger">*</span></label>
                <input type="text" class="form-control" id="inputStrasse" name="strasse" placeholder="Strasse" formControlName="strasse">
            </div>
            <div class="form-group">
                <label class="control-label" for="inputPlz">Postleitzahl<span class="text-danger">*</span></label>
                <input type="text" class="form-control" id="inputPlz" name="plz" placeholder="Postleitzahl" formControlName="plz">
            </div>
            <div class="form-group">
                <label class="control-label" for="inputOrt">Ort<span class="text-danger">*</span></label>
                <input type="text" class="form-control" id="inputOrt" name="ort" placeholder="Ort" formControlName="ort">
            </div>
      </form>
  </div>
  <div class="modal-footer">
  <button type="submit" class="btn btn-success round" (click)="onSubmit()">Hinzufügen</button>
  <button type="reset" class="btn round bg-red" style="color: white;" (click)="activeModal.close('Schließen')">Schließen</button>
  </div>
